module.exports = __webpack_public_path__ + "e73ca7fe1b1075ad4dddc91a6225f1a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shop_goods_2.jpg
// module id = 208
// module chunks = 1